import type { ReactNode } from "react";
import styled from "styled-components";

interface WorkPolicyScheduleScrollFrameProps {
  children: ReactNode;
  label: string;
  title: string;
}

const Frame = styled.div`
  width: 100%;
  min-width: 0;
  overflow: hidden;
  border: 1px solid ${props => props.theme.colors.grey};
  border-radius: 8px;
  background: ${props => props.theme.colors.lightGrey};
`;

const BoundaryLabel = styled.div`
  display: flex;
  min-height: 34px;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 6px 12px;
  border-bottom: 1px solid ${props => props.theme.colors.grey};
  color: ${props => props.theme.colors.darkGrey};
  font-size: 12px;

  strong {
    color: ${props => props.theme.colors.midNightBlue};
    font-size: 13px;
  }
`;

const ScheduleViewport = styled.div`
  box-sizing: border-box;
  max-height: 400px;
  min-width: 0;
  overflow: auto;
  overscroll-behavior: contain;
  scrollbar-gutter: stable;
  padding: 12px;
  background: ${props => props.theme.colors.white};
  box-shadow: inset 0 10px 14px -16px rgba(15, 23, 42, 0.7),
    inset 0 -10px 14px -16px rgba(15, 23, 42, 0.7);

  &:focus-visible {
    outline: 2px solid ${props => props.theme.colors.darkBlue};
    outline-offset: -2px;
  }
`;

export function WorkPolicyScheduleScrollFrame({
  children,
  label,
  title
}: WorkPolicyScheduleScrollFrameProps) {
  return (
    <Frame>
      <BoundaryLabel aria-hidden="true">
        <strong>{title}</strong>
        <span>↕ 안쪽 스크롤</span>
      </BoundaryLabel>
      <ScheduleViewport role="region" aria-label={label} tabIndex={0}>
        {children}
      </ScheduleViewport>
    </Frame>
  );
}
